export const IS_ELECTRON =
  import.meta.env.VITE_BUILD_TARGET === 'electron' ||
  window.location.protocol === 'file:' ||
  new URLSearchParams(window.location.search).has('proxyToken')
